import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum LockConnectionParamTypeId {
  HOST = 'host',
  PORT = 'port',
  RETENTION_MODE = 'retentionMode',
  USERNAME = 'username',
  PASSWORD = 'password',
  PASSWORD_HASH = 'passwordHash',
  CLIENT_ID = 'clientId',
  CLIENT_SECRET = 'clientSecret',
  EXPANDED_KEY_NAME = 'expandedKeyName',
  DEVICE_ID = 'deviceId',
  API_KEY = 'apiKey',
  PIN_LENGTH = 'pinLength',
  SITE_ID = 'siteId',
  ROLE_ID = 'roleId',
  KEYGURU_PLATFORM = 'keyguruPlatform',
}

export enum KeyguruPlatform {
  OLD = 'old',
  NEW = 'new',
}

export type LockConnectionParamOption = {
  id: string
  name: () => string
}

export class LockConnectionParamType extends Codebook<LockConnectionParamTypeId> {
  static readonly HOST = new LockConnectionParamType(LockConnectionParamTypeId.HOST, () =>
    $t('Host'),
  )
  static readonly PORT = new LockConnectionParamType(LockConnectionParamTypeId.PORT, () =>
    $t('Port'),
  )
  static readonly RETENTION_MODE = new LockConnectionParamType(
    LockConnectionParamTypeId.RETENTION_MODE,
    () => $t('Retention mode'),
  )
  static readonly USERNAME = new LockConnectionParamType(LockConnectionParamTypeId.USERNAME, () =>
    $t('Username'),
  )
  static readonly PASSWORD = new LockConnectionParamType(LockConnectionParamTypeId.PASSWORD, () =>
    $t('Password'),
  )
  static readonly PASSWORD_HASH = new LockConnectionParamType(
    LockConnectionParamTypeId.PASSWORD_HASH,
    () => $t('Password hash'),
  )
  static readonly CLIENT_ID = new LockConnectionParamType(LockConnectionParamTypeId.CLIENT_ID, () =>
    $t('Client ID'),
  )
  static readonly CLIENT_SECRET = new LockConnectionParamType(
    LockConnectionParamTypeId.CLIENT_SECRET,
    () => $t('Client secret'),
  )
  static readonly EXPANDED_KEY_NAME = new LockConnectionParamType(
    LockConnectionParamTypeId.EXPANDED_KEY_NAME,
    () => $t('Expanded key name'),
  )
  static readonly DEVICE_ID = new LockConnectionParamType(LockConnectionParamTypeId.DEVICE_ID, () =>
    $t('Device ID'),
  )
  static readonly API_KEY = new LockConnectionParamType(LockConnectionParamTypeId.API_KEY, () =>
    $t('API key'),
  )
  static readonly PIN_LENGTH = new LockConnectionParamType(
    LockConnectionParamTypeId.PIN_LENGTH,
    () => $t('PIN length'),
  )
  static readonly SITE_ID = new LockConnectionParamType(LockConnectionParamTypeId.SITE_ID, () =>
    $t('Site ID'),
  )
  static readonly ROLE_ID = new LockConnectionParamType(LockConnectionParamTypeId.ROLE_ID, () =>
    $t('Role ID'),
  )
  static readonly KEYGURU_PLATFORM = new LockConnectionParamType(
    LockConnectionParamTypeId.KEYGURU_PLATFORM,
    () => $t('Platform'),
    [
      {
        id: KeyguruPlatform.OLD,
        name: () => $t('Old ({url})', { url: 'https://keyguru.app/api/v1' }),
      },
      {
        id: KeyguruPlatform.NEW,
        name: () => $t('New ({url})', { url: 'https://api.keyguru.app/api/v1' }),
      },
    ],
    KeyguruPlatform.NEW,
  )

  private constructor(
    id: LockConnectionParamTypeId,
    public readonly name: () => string,
    public readonly options: LockConnectionParamOption[] | null = null,
    public readonly defaultValue: string | null = null,
  ) {
    super(id)
  }
}
